import type { AudioRecorderMimeSupport } from "../types";

export const AUDIO_TRANSCRIPTION_MAX_DURATION_SECONDS = 5 * 60;
export const AUDIO_RECORDER_MAX_DURATION_MS =
  AUDIO_TRANSCRIPTION_MAX_DURATION_SECONDS * 1000;

const RECORDER_MIME_CANDIDATES: AudioRecorderMimeSupport[] = [
  { mimeType: "audio/ogg;codecs=opus", fileExtension: ".ogg" },
  { mimeType: "audio/ogg", fileExtension: ".ogg" },
  { mimeType: "audio/mp4;codecs=mp4a.40.2", fileExtension: ".m4a" },
  { mimeType: "audio/mp4", fileExtension: ".m4a" },
  { mimeType: "audio/webm;codecs=opus", fileExtension: ".webm" },
  { mimeType: "audio/webm", fileExtension: ".webm" },
  { mimeType: "audio/wav", fileExtension: ".wav" },
  { mimeType: "audio/aac", fileExtension: ".aac" },
];

export function isAudioRecordingSupported(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof MediaRecorder !== "undefined" &&
    typeof navigator !== "undefined" &&
    !!navigator.mediaDevices?.getUserMedia
  );
}

export function getSupportedAudioRecorderMimeType(): AudioRecorderMimeSupport | null {
  if (!isAudioRecordingSupported()) {
    return null;
  }

  if (typeof MediaRecorder.isTypeSupported !== "function") {
    return RECORDER_MIME_CANDIDATES[0] ?? null;
  }

  return (
    RECORDER_MIME_CANDIDATES.find(({ mimeType }) =>
      MediaRecorder.isTypeSupported(mimeType),
    ) ?? null
  );
}

export function buildAudioRecordingFileName(fileExtension: string): string {
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  return `audio-recording-${timestamp}${fileExtension}`;
}
